/**
 * Shared Email Validation
 * Reusable email validation pattern used across features
 */

import { z } from "zod";

/**
 * Email regex pattern
 * Matches standard email format: user@domain.tld
 */
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Zod schema for email validation
 * - Required field
 * - Must be valid email format
 */
export const emailSchema = z
  .string()
  .min(1, "Email is required")
  .email("Please enter a valid email address");

/**
 * Validate email without Zod (for simple checks)
 */
export const isValidEmail = (email: string): boolean => emailRegex.test(email);
